import React, { useEffect, useState } from "react";
import { useCookies } from 'react-cookie';
import { Container } from "@mui/material";

import { axiosPost } from "../../services/axios/apiCalls";
import SuccessModal from "../modals/successModal"
import AxiosError from "../modals/axiosErrorModal"
import SetLoading from "../loading/setLoading";

export default function ChangePassword({ code, username, domain = null, oldPassword = null, newPassword, uri, open, onClose }) {
    const [isSuccess, setIsSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const data = {
        code,
        username,
        domain,
        oldPassword,
        newPassword,
    }

    const handleCloseSuccess = async () => {
        if (onClose) {
            setIsLoading(true)
            await onClose(username, newPassword);
            setIsLoading(false)
        }
    }


    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosPost(uri, data);
                if (response.status === 200) {
                    setMessage('Contraseña cambiada exitosamente.')
                    setIsSuccess(true);
                } else
                    setMessage(response.message)
                setStatus(response.status)
                setIsLoading(false)
            } catch (error) {
                setMessage(error.message)
                setStatus(error.status)
                setIsLoading(false)
            }
        };
        fetchData();
    },[code, username, newPassword])

    if (isLoading) {
        return <SetLoading />;
    }

    return isSuccess ? (
        <SuccessModal open={open} onClose={onClose ? handleCloseSuccess: null} message={message} />
    ) : (
        <AxiosError open={open} onClose={onClose ? handleCloseSuccess: null} status={status} message={message} />
    );
};
